import { StyleSheet } from 'react-native';

import { Fonts } from 'assets/fonts';

import { COLOR, lightGrey } from 'utils/colors';
import {
    androidScreenMarginBottom,
    isTablet,
    isTabletOrWeb,
    widthPercentageToDP,
} from 'utils/responsiveness';

const styles = StyleSheet.create({
    dialog: {
        backgroundColor: COLOR.BLACK,
        marginBottom: androidScreenMarginBottom,
    },
    button: {
        minWidth: isTabletOrWeb ? 120 : widthPercentageToDP(328),
        width: 'auto',
        backgroundColor: COLOR.primary,
        borderColor: COLOR.primary,
    },
    actionButtonText: {
        color: COLOR.BLACK,
    },
    descriptionText: {
        marginTop: 16,
        fontFamily: Fonts.main.regular,
        fontSize: 16,
        textAlign: 'center',
        color: COLOR.NEUTRAL_GRAY,
    },
    progressBar: {
        flexDirection: 'row',
        width: isTablet ? '70%' : '100%',
        height: 10,
        marginTop: 10,
        borderRadius: 10,
        backgroundColor: COLOR.DARK_GREY,
        overflow: 'hidden',
    },
    emptyProgressBar: {
        flexDirection: 'row',
        width: isTablet ? '70%' : '100%',
        height: 10,
        marginTop: 68,
        borderRadius: 10,
        backgroundColor: COLOR.DARK_GREY,
    },
    usedQuota: {
        backgroundColor: COLOR.WHITE,
        borderRadius: 10,
    },
    protectedQuota: {
        flex: 1,
    },
    hoursStatus: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        width: isTablet ? '70%' : '100%',
        marginTop: 40,
    },
    usedHours: { flexDirection: 'row' },
    hoursText: {
        fontFamily: Fonts.main.regular,
        fontSize: 14,
        textAlign: 'center',
        color: lightGrey(),
    },
    selfcareButton: {
        marginBottom: 24,
    },
    buttonText: {
        color: COLOR.primary,
    },
});

export default styles;
